import { Backdrop, Button, Grid, Typography } from "@material-ui/core";
import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import { compose } from "redux";
import PropTypes from "prop-types";

import background from "./../../assets/images/background.png";

const styles = (theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    width: "100%",
    height: "100vh",
    backgroundColor: "#FF6400",
    backgroundImage: `url('${background}')`,
    backgroundSize: "120% 102%",
    backgroundPosition: "center center",
    backgroundRepeat: "no-repeat",
    display: "block",
    position: "relative",
  },
  content: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%,-50%)",
  },
  title: {
    fontWeight: 700,
    fontSize: "40px",
    lineHeight: "55px",
    color: "#FFFFFF",
    marginBottom: "30px",
  },
  btn: {
    borderRadius: "24px",
    backgroundColor: "#FFFFFF",
    color: "#FF6400",
    padding: "14px 32px",
    boxShadow: "none",
    borderColor: "#FF6400",
    "&:hover": {
      backgroundColor: "#FFFFFF",
      color: "#CC5000",
      boxShadow: "none",
      borderColor: "#CC5000",
    },
  },
});

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      error: error,
      errorInfo: errorInfo,
    });
  }

  render() {
    const { classes } = this.props;
    if (this.state.hasError) {
      return (
        <Backdrop className={classes.backdrop} open={true}>
          <div className={classes.content}>
            <Grid
              container
              direction="column"
              justifyContent="center"
              alignItems="center"
            >
              <Typography variant="h2" className={classes.title}>
                Oops! Something went wrong.
              </Typography>
              <Button
                variant="outlined"
                color="primary"
                className={classes.btn}
                onClick={() => {
                  localStorage.removeItem("user");
                  window.location.reload();
                }}
              >
                Refresh
              </Button>
            </Grid>
          </div>
        </Backdrop>
      );
    }

    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  classes: PropTypes.object,
  children: PropTypes.any,
};

export default compose(withStyles(styles))(ErrorBoundary);
